<section class="news_Sention">
    <div class="container">
        <div class="mews_SecHead">
            <h2>INTEGRITY ASSURED</h2>
            <p>
                {{ 'LANDING_PAGE.PRODUCT_DETAIL_TEXT.JOINT_INTEGRITY' | transloco }}
            </p>
        </div>
        <div class="inner_news">
            <div class="row">
                <div class="col-sm-6 col-lg-4">
                    <div class="news_wrap">
                        <div class="news_box">
                            <div class="news_img">
                                <a href="#"><img src="./assets/media/logos/{{ IA }}" /></a>
                            </div>
                            <div class="prod_desc">
                                <p>
                                    {{ 'LANDING_PAGE.PRODUCT_DETAIL_TEXT.HYDRATIGHT' | transloco }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <div class="news_wrap">
                        <div class="news_box">
                            <div class="news_img">
                                <a href="#"><img src="./assets/media/logos/{{ PA }}" /></a>
                            </div>

                            <div class="prod_desc">
                                <p>
                                    {{ 'LANDING_PAGE.PRODUCT_DETAIL_TEXT.IDMS' | transloco }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4">
                    <div class="news_wrap">
                        <div class="news_box">
                            <div class="news_img">
                                <a href="#"><img src="./assets/media/logos/{{ JA }}" /></a>
                            </div>

                            <div class="prod_desc">
                                <p>
                                    {{ 'LANDING_PAGE.PRODUCT_DETAIL_TEXT.INFORMATE' | transloco }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
